import {Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';

@Component({
    selector: 'ui-file-field',
    templateUrl: './file-field.component.html',
    styles: [':host { display: block; min-width: 0; }']
})
export class FileFieldComponent {
    @Input() inputId = '';
    @Input() label = '';
    @Input() accept = '.pdf,.jpg,.jpeg,.png';
    @Input() fileUrl = '';
    @Input() placeholder = 'Scegli un file';
    @Input() hint = 'PDF, JPG o PNG';
    @Input() icon = 'bi-paperclip';
    @Input() disabled = false;

    @Output() fileChange = new EventEmitter<Event>();

    @ViewChild('fileInput') fileInput?: ElementRef<HTMLInputElement>;

    selectedName = '';

    get displayName(): string {
        return this.selectedName || this.fileNameFromUrl(this.fileUrl);
    }

    openPicker(): void {
        if (!this.disabled) {
            this.fileInput?.nativeElement.click();
        }
    }

    onFileChange(event: Event): void {
        const input = event.target as HTMLInputElement;
        this.selectedName = input.files?.[0]?.name ?? '';
        this.fileChange.emit(event);
    }

    private fileNameFromUrl(url?: string): string {
        if (!url) {
            return '';
        }
        try {
            return decodeURIComponent(url.split('?')[0].split('/').pop() ?? '');
        } catch {
            return '';
        }
    }
}
